export namespace RouteSegments {
  export const NotFound = '404';
  export const DetailsId = ':id';
  export const Help = '/help/';

  export enum Root {
    Dashboard = 'dashboard',
    Config = 'config',
    Reporting = 'reporting',
    RiskManagement = 'risk-management',
    Goto = 'goto',
  }

  export enum Goto {
    Help = 'help',
  }

  export enum Config {
    Settings = 'settings',
    Symbols = 'symbols',
    Markups = 'markups',
    OrderRouting = 'routing',
    PricingSettings = 'pricing',
    Profiles = 'profiles',
    Rules = 'rules',
    Alerts = 'alerts',
    ExternalReporting = 'external-reporting',
  }

  export enum ExternalReporting {
    Reports = 'reports',
    Servers = 'servers',
  }

  export const ExternalReportingRuleSetId = ':rulesetId';

  export enum Symbols {
    Core = 'core',
    Synthetic = 'synthetic',
    Client = 'client',
    LP = 'lp',
  }

  export enum Lps {
    Symbols = 'lps/:lpId/symbols',
  }

  export enum Servers {
    Symbols = 'servers/:serverId/symbols',
  }

  export enum Markups {
    Profile = ':profileId/symbols',
  }

  export enum Rules {
    OrderRouting = 'routing',
    OrderLifetime = 'order-lifetime',
    Adjustment = 'adjustment',
    PricingRules = 'pricing',
    PriceFilteringRules = 'price-filtering',
  }

  export enum Profiles {
    Routing = 'routing',
    Schedule = 'schedule',
    OrderLifetime = 'order-lifetime',
    Adjustment = 'adjustment',
    PriceFiltering = 'price-filtering',
    Pricing = 'pricing',
    Spread = 'spread',
  }

  export enum Schedule {
    Interval = ':id/intervals/:index?',
  }

  export enum Settings {
    Users = 'users',
    Streams = 'streams',
    Servers = 'servers',
    LiquidityProviders = 'lps',
  }

  export enum Alerts {
    Settings = 'settings',
    Emails = 'emails',
  }

  export enum Pools {
    Streams = 'pools/:nodeId/streams',
    Symbols = 'pools/:nodeId/symbols',
  }

  export enum Reporting {
    Executions = 'executions',
    Orders = 'orders',
    Exposure = 'exposure',
    TradingVolume = 'trading-volume',
    ConversionRates = 'conversion-rates',
  }

  export enum RiskManagement {
    Markout = 'markout',
  }

  export enum Dashboards {
    ConnectionStatus = 'connection-status',
    Exposure = 'exposure',
    PerformanceMetrics = 'performance-metrics',
    BusinessMetrics = 'business-metrics',
    BillingMetrics = 'billing-metrics',
    Alerts = 'alerts',
    Prices = 'prices',
  }

  export enum DashboardPrices {
    Servers = 'servers/:serverId',
    Lps = 'lps/:lpId',
  }
}

export enum Page {
  CoreSymbols = 'coreSymbols',
  SyntheticSymbols = 'syntheticSymbols',
  LpSymbols = 'lpSymbols',
  ClientSymbols = 'clientSymbols',
  AdjustmentRules = 'adjustmentRules',
  OrderLifetimeRules = 'orderLifetimeRules',
  RoutingRules = 'routingRules',
  PricingRules = 'pricingRules',
  PriceFilteringRules = 'priceFilteringRules',
  Markups = 'markups',
  RoutingProfiles = 'routingProfiles',
  OrderLifetimeProfiles = 'orderLifetimeProfiles',
  AdjustmentProfiles = 'adjustmentProfiles',
  PriceFilteringProfiles = 'priceFilteringProfiles',
  PricingProfiles = 'pricingProfiles',
  ScheduleProfiles = 'scheduleProfiles',
  ScheduleProfileIntervals = 'scheduleProfileIntervals',
  Streams = 'streams',
  Servers = 'servers',
  Users = 'users',
  Lp = 'lp',
  AlertSettings = 'alertSettings',
  AlertEmails = 'alertEmails',
}

export const DefaultRoutes = {
  Index: `/${RouteSegments.Root.Dashboard}`,
  NotFound: `/${RouteSegments.NotFound}`,
  Config: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Symbols}`,
  ConfigSymbols: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.Core}`,
  ConfigLpSymbols: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Symbols}/${RouteSegments.Symbols.LP}`,
  ConfigOrderRouting: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Rules}/${RouteSegments.Rules.OrderRouting}`,
  ConfigPricingRules: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Rules}/${RouteSegments.Rules.PricingRules}`,
  ConfigProfiles: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}/${RouteSegments.Profiles.Routing}`,
  // Profiles landing page without the basicBridge feature (routing profiles are hidden then)
  ConfigProfilesPricing: `/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}/${RouteSegments.Profiles.Pricing}`,
  ConfigSettings: `/${RouteSegments.Root.Config}/${RouteSegments.Settings.Users}`,
  ConfigExternalReporting:
    `/${RouteSegments.Root.Config}/${RouteSegments.Config.ExternalReporting}/${RouteSegments.ExternalReporting.Reports}`,
  DashboardPrices: `/${RouteSegments.Root.Dashboard}/${RouteSegments.Dashboards.Prices}`,
};
